import {
  CoAuthorSummaryListBuilder,
  CoAuthorSummaryListBuilderProps,
  ListBuilderQuerySearchResult,
} from '@workboard/ui-summary';
import React from 'react';
import {
  ThemeProvider, ScopedCssBaseline, styled, SxProps, dialogClasses,
  dialogTitleClasses,
  buttonClasses,
  dialogContentClasses,
  stackClasses,
  outlinedInputClasses
} from '@mui/material';
import { GlobalStyle, theme } from './theme/theme';

const searchApiBaseUrl = `${window.location.origin}/wb/vnext/searchApi`;

const dialogStyle: SxProps = {
  [`& .${dialogClasses.paper}`]: {
    width: 'min(100vw, 680px)',
    maxWidth: 680,
    borderRadius: 8,
    maxHeight: '100%',
  },
  [`& .${dialogTitleClasses.root}`]: {
    display: 'flex',
    justifyContent: 'space-between',
    height: 60,
    padding: 16,
    marginBottom: 0,
    [`& .${buttonClasses.root}`]: {
      borderRadius: 6,
      minWidth: 'unset',
    },
  },
  '& form': {
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${dialogContentClasses.root}`]: {
    padding: '0px 16px 0px 16px',
    maxHeight: '100%',
    [`& .${stackClasses.root}`]: {
      marginTop: 0,
    },
  },

  [`& .${dialogContentClasses.dividers}`]: {
    borderTop: '1px solid rgba(0, 0, 0, 0.06)',
  },

  [`& .${outlinedInputClasses.root}`]: {
    backgroundColor: '#FFF !important',
  },

  [`& .${outlinedInputClasses.input}`]: {
    '-webkit-text-fill-color': '#333943',
  },
};

const StyledCssBaseline = styled(ScopedCssBaseline)({
  'div#list-dialog &': {
    '& .MuiDialogTitle-root': {
      height: '60px !important',
    },
    '& button': {
      'font-size': '14px',
    },
  },
});

type ListBuilderProps = {
  listId?: number;
  onSave: (listId: number) => void;
  onCancel: () => void;
  resourceType?: string;
};

function ListBuilder ({
  listId, resourceType, onSave, onCancel
}: ListBuilderProps) {
  const [open, setOpen] = React.useState(true);

  const currentUser: CoAuthorSummaryListBuilderProps['currentUser'] = {
    id: window.uData.user_id,
    fullName: `${window.uData.first_name} ${window.uData.last_name}`,
    email: window.uData.email,
    picture: window.uData.picture,
    isReadOnly: window.uData.userIsReadOnly,
  };
  const isRBROrScorecardType = resourceType === 'scorecard' || resourceType === 'bizreview';

  const listProps: CoAuthorSummaryListBuilderProps = {
    onSave: (list: ListBuilderQuerySearchResult) => {
      onSave?.(+list.id);
      setOpen(false);
    },
    onCancel: () => {
      onCancel?.();
      setOpen(false);
    },
    open,
    currentUser,
    id: listId,
    baseUrl: searchApiBaseUrl,
    hideSubscription: !window.wbConfig.scheduledBriefsEnabled,
    resourceType,
    hideFilterQueryDropdown: isRBROrScorecardType,
    dialogStyle: isRBROrScorecardType ? dialogStyle : undefined,
    disableTitleField: isRBROrScorecardType,
    showScope: isRBROrScorecardType,
  };

  return (
    <StyledCssBaseline>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <CoAuthorSummaryListBuilder {...listProps} />
      </ThemeProvider>
    </StyledCssBaseline>
  );
}

export default ListBuilder;
